<app-modal-filler-atom
  (click)="onClose()"
  [index]="10"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center mdMax:bottom-0 mdMax:mx-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm"
  [style.z-index]="60"
>
  <app-modal-filler-atom
    class="hidden md:block"
    [withBackdrop]="false"
    (onClick)="onClose()"
    [index]="10"
  ></app-modal-filler-atom>
  <div
    class="rounded-t-3xl bg-white p-5 md:w-2/5 md:min-w-448 md:max-w-lg md:rounded-3xl md:p-7"
    [style.z-index]="60"
  >
    @if (activeStep === registrationStep.ZEROSIX_STEP_PHONE) {
      <app-zerosix-phone-number-step
        [phone]="phone ?? ''"
        (setPhone)="setPhone($event)"
        (goToNextStep)="onGoToOtpStep()"
        (goToAuthenticationStep)="onGoToAuthenticationStep()"
        (goToAccountNotFoundStep)="onGoToAccountNotFoundStep()"
        (goToKioskAccountNotFoundStep)="onGoToKioskAccountNotFoundStep()"
        (onClose)="onClose()"
        [accentColor]="actionFieldColor"
      ></app-zerosix-phone-number-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_OTP) {
      <app-zerosix-otp-step
        [phone]="phone"
        [actionFieldColor]="actionFieldColor"
        (onClose)="onClose()"
        (goToPreviousStep)="onGoToPhoneStep()"
        (goToNextStep)="onGoToKioskRegisterConfirmationStep()"
      ></app-zerosix-otp-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_AUTHENTICATION) {
      <app-zerosix-authentication-step
        [actionFieldColor]="actionFieldColor"
        (onClose)="onClose()"
        (onComplete)="onComplete()"
        (onKioskConfirm)="onGoToConfirmationStep()"
      ></app-zerosix-authentication-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_KIOSK_CONFIRMATION) {
      <app-kiosk-confirmation-step
        (onComplete)="onComplete()"
        [fidelityType]="FidelityType.ZEROSIX"
        [accentColor]="actionFieldColor"
      ></app-kiosk-confirmation-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_KIOSK_REGISTER) {
      <app-kiosk-register-step
        [phone]="phone ?? ''"
        [fidelityType]="FidelityType.ZEROSIX"
        [accentColor]="actionFieldColor"
        (onClose)="onClose()"
        (setPhone)="setPhone($event)"
        (goToKioskRegisterConfirmationStep)="onGoToKioskRegistrationSuccessStep()"
      ></app-kiosk-register-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_KIOSK_REGISTER_CONFIRMATION) {
      <app-kiosk-register-confirmation-step
        (onComplete)="onComplete()"
        [fidelityType]="FidelityType.ZEROSIX"
        [accentColor]="actionFieldColor"
      ></app-kiosk-register-confirmation-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_KIOSK_REGISTRATION_SUCCESS) {
      <app-kiosk-registration-success-step
        (onComplete)="onComplete()"
        [fidelityType]="FidelityType.ZEROSIX"
        [accentColor]="actionFieldColor"
      ></app-kiosk-registration-success-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_KIOSK_ACCOUNT_NOT_FOUND) {
      <app-kiosk-account-not-found-step
        [phone]="phone ?? ''"
        [fidelityType]="FidelityType.ZEROSIX"
        [accentColor]="actionFieldColor"
        (goToPhoneStep)="onGoToPhoneStep()"
        (goToRegisterStep)="onGoToRegisterStep()"
        (onComplete)="onComplete()"
      ></app-kiosk-account-not-found-step>
    }
    @if (activeStep === registrationStep.ZEROSIX_STEP_ACCOUNT_NOT_FOUND) {
      <app-zerosix-account-not-found-step
        (onClose)="onClose()"
        (goToPhoneStep)="onGoToPhoneStep()"
      ></app-zerosix-account-not-found-step>
    }
  </div>
</div>
